'use client'
import { trackEvent } from '@/lib/trackEvent'
import Link from 'next/link'
import { useAuth } from '@/context/AuthContext'

export default function GuestSignupCTA({ headline, ariaLabel }) {
  const { currentUser } = useAuth()
  if (currentUser) return null

  return (
    <div className="mb-5 rounded-xl border border-blue-200 bg-gradient-to-r from-blue-50 to-indigo-50 px-4 py-4 shadow-sm">
      <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-3">
        <div className="min-w-0">
          <p className="text-sm font-bold text-blue-900">{headline}</p>
          <ul className="mt-1.5 space-y-0.5 text-xs text-blue-700">
            <li>🏠 Deals from your home airport, first</li>
            <li>🆓 Free to start — no credit card needed</li>
            <li>⚡ Plus &amp; Pro unlock all deals &amp; features</li>
          </ul>
        </div>
        <Link
          href="/signup"
          onClick={() => trackEvent('signup_cta', { label: 'Sign up free', component: 'GuestSignupCTA' }, 'guest')}
          aria-label={ariaLabel || "Sign up free"}
          className="self-start sm:shrink-0 rounded-lg bg-blue-600 px-4 py-2 text-xs font-bold text-white hover:bg-blue-700 transition-colors shadow-sm"
        >
          Sign up free →
        </Link>
      </div>
    </div>
  )
}
